import { FC } from 'react';

import { search } from '@purpur/library/icon/assets/search';

import { NavBarSearchConnected } from '@telialt/core-search/src/SearchComponents/NavBarSearch/NavBarSearchConnected';
import { NavigationItem } from '@telialt/models/src/Navigation';

import { NAVIGATION_MAIN_BAR_HEIGHT } from '../../constants';
import { MenuItemIcon } from '../MenuItem/MenuItem.styles';
import { SearchCloseButton, SearchOpenButton } from './MenuItemSearch.styles';

interface Props {
    item: NavigationItem;
}

export const MenuItemSearch: FC<Props> = ({ item }) => {
    const { title, colorOption, displayOption } = item;

    return (
        <NavBarSearchConnected
            navigationBarHeight={NAVIGATION_MAIN_BAR_HEIGHT}
            components={{
                openButton: (props) => (
                    <SearchOpenButton $colorOption={colorOption} $displayOption={displayOption} {...props}>
                        <MenuItemIcon svg={search} size="sm" />
                        {title}
                    </SearchOpenButton>
                ),
                closeButton: (props) => (
                    <SearchCloseButton $colorOption={colorOption} $displayOption={displayOption} {...props} />
                ),
            }}
        />
    );
};
